import * as React from 'react';
import { useDraggable, useDroppable } from '@dnd-kit/react';
import { NavItem } from 'Interfaces/Admin';
import NavListItem from './NavListItem';

interface Props {
  item: NavItem;
  selected: boolean;
  onTrail: boolean;
  onSelect: () => void;
  onDrillDown: () => void;
}

export const dragId = (item: { type: string; id: number }): string => `admin-drag-${item.type}-${item.id}`;
export const dropId = (groupId: number): string => `admin-drop-group-${groupId}`;

/**
 *  A draggable row inside a column. Groups are also drop targets, which is how
 *  users and groups get reparented — the behaviour jquery-ui-draggable-collision
 *  used to provide in admin.js.
 */
export default function ColumnItem(props: Props) {
  const { item } = props;

  const { ref: dragRef } = useDraggable({
    id: dragId(item),
    data: { type: item.type, id: item.id },
  });

  const { ref: dropRef, isDropTarget } = useDroppable({
    id: dropId(item.id),
    disabled: item.type !== 'group',
    data: { id: item.id },
    // A row may not be dropped onto itself.
    accept: (source) => source.id !== dragId(item),
  });

  return (
    <div
      ref={item.type === 'group' ? dropRef : undefined}
      className={isDropTarget ? 'collided' : ''}
    >
      <div ref={dragRef} className="draggable">
        <NavListItem
          item={item}
          selected={props.selected}
          onTrail={props.onTrail}
          onSelect={props.onSelect}
          onDrillDown={props.onDrillDown}
        />
      </div>
    </div>
  );
}
